import { features } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-6 md:px-10 py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary-500 bg-primary-100 px-4 py-1.5 rounded-full mb-4">
            核心功能
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为团队协作而生的一站式起草平台
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            六大核心功能，覆盖从起草到定稿的完整协作流程
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 rounded-lg bg-background-100/70 hover:bg-background-100 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}